import { FilterItem } from '@wconcept/wconcept-common/models/renewal/common';
import Box from '@wconcept/wconcept-ui-renewal/components/atoms/Box';
import FltColorItem from '@wconcept/wconcept-ui-renewal/components/molecules/_item/FltColorItem';
import FltBenefitBox from '../../_list/FltBenefitBox';

function ColorContent({
  colorList,
  isItemSelected,
  onChangeColor,
  hideFilterOptionCounts,
}: {
  colorList?: FilterItem[] | null;
  isItemSelected: (filterType: string, item: FilterItem) => boolean;
  onChangeColor: (color: FilterItem) => void;
  hideFilterOptionCounts?: boolean;
}) {
  return (
    <Box className="coner-color">
      <FltBenefitBox
        items={colorList?.map((color: FilterItem) => (
          <FltColorItem
            key={color.code}
            cnt={hideFilterOptionCounts ? undefined : color.count}
            color={color.hex}
            colorUrl={
              !color.hex || color.hex === 'multi' ? color.url : undefined
            }
            active={isItemSelected('color', color)}
            text={color.name}
            onClick={() => onChangeColor(color)}
          />
        ))}
      />
    </Box>
  );
}

export default ColorContent;
